"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function PageIndicator(_ref) {
  var currentItemFrom = _ref.currentItemFrom,
      itemTo = _ref.itemTo,
      textOf = _ref.textOf,
      totalItems = _ref.totalItems,
      itemLabel = _ref.itemLabel,
      testId = _ref.testId;
  return _react2.default.createElement("div", {
    className: "c-muted-2 t-small",
    "data-testid": testId
  }, currentItemFrom + " - " + itemTo + " ", textOf, " ", totalItems, " ", itemLabel);
}

PageIndicator.defaultProps = {
  itemLabel: ''
};
PageIndicator.propTypes = {
  currentItemFrom: _propTypes2.default.number.isRequired,
  itemTo: _propTypes2.default.number.isRequired,
  textOf: _propTypes2.default.string.isRequired,
  totalItems: _propTypes2.default.node.isRequired,
  itemLabel: _propTypes2.default.node,
  testId: _propTypes2.default.string
};
exports.default = PageIndicator;